import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { client } from "../../helpers/api/apiCall";

const initialState = {
  accessToken: {
    token:'',
  },
  loading: false,
};

export const login = createAsyncThunk("login", async (body) => {
  const response = await client.post(
    "https://servis.kuranhayatim.com/api/Auth/Login",
    body
  );
  return response.data;
});

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(login.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.loading = false;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default authSlice.reducer;
